export default "__VITE_ASSET__Dfhm0iKQ__"